import React from 'react'

// UI Components
import Header from './Header/Header'
import Preloader from './Preloader/Preloader'
import Home from './Home/Home'
import About from './About/About'
import Experience from './Experience/Experience'
import Projects from './Projects/Projects'
import Contact from './Contact/Contact'


const App = () => (
  <div>
    <Preloader />
    <Header />
    <Home />
    <About />
    <Experience />
    <Projects />
    <Contact />
  </div>
)

export default App
